import { codeLabel } from '@bemor/web-kit';

import type { PaymentSystemOffer } from '@/api/types';

/**
 * One answer of `/staff/payment-systems/merchants/{merchant}/offer` in words (BM-70 § 10): `offered` decides, `reason`
 * only words a refusal. `linked` (an account serves the system) turns not_assigned, which only says no enablement row
 * exists, into "Not switched on", so staff never read it as "no account" (V-11; the API reason stays not_assigned).
 */
export function offerText(
    o: Pick<PaymentSystemOffer, 'offered' | 'reason'>,
    { linked = false }: { linked?: boolean } = {},
): string {
    if (o.offered) return 'Offered';
    return linked && o.reason === 'not_assigned'
        ? 'Not offered: Not switched on'
        : `Not offered: ${codeLabel(o.reason ?? 'not_available')}`;
}
